export const DEACTIVATION_REASONS = [
  "Completed Program",
  "Patient Declined",
  "Lost Contact",
  "Not Eligible",
  "Clinic Requested Closure",
  "Administrative Closure",
  "Other",
];

export const isCoCMSuperAdmin = (user) =>
  user?.role === "admin" && !user?.businessIdentifier;
